import { useFlow } from '@edreamsodigeo/frontend-core';

export const useFlowComponent = (MobileComponent, DesktopComponent) => {
  return useFlow() === 'mobile' ? MobileComponent : DesktopComponent;
};
